import { useState, useEffect } from 'react';
import { TopNav } from '@/components/layout/TopNav';
import { PostManager } from '@/components/publishing/PostManager';
import { Composer } from '@/components/publishing/Composer';
import { CaptureModal } from '@/components/publishing/CaptureModal';
import { useSearchParams, useLocation } from 'react-router-dom';

export function Publishing() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const [composerOpen, setComposerOpen] = useState(false);
  const [initialMediaKeys, setInitialMediaKeys] = useState<string[]>([]);
  const [initialContent, setInitialContent] = useState<string | undefined>(undefined);
  const [editPostId, setEditPostId] = useState<string | undefined>(undefined);
  const [captureOpen, setCaptureOpen] = useState(false);

  useEffect(() => {
    if (searchParams.get('compose') === 'true') {
      const mediaParam = searchParams.get('media');
      setInitialMediaKeys(mediaParam ? [mediaParam] : []);
      // Router state carries a caption prefill (e.g. "Use this idea" from Trends).
      const state = location.state as { prefillContent?: string } | null;
      setInitialContent(state?.prefillContent);
      setEditPostId(undefined);
      setComposerOpen(true);
      setSearchParams({}, { replace: true });
    }
  }, [searchParams]);

  const openComposer = () => {
    setInitialMediaKeys([]);
    setInitialContent(undefined);
    setEditPostId(undefined);
    setComposerOpen(true);
  };

  const openEditor = (postId: string) => {
    setInitialMediaKeys([]);
    setInitialContent(undefined);
    setEditPostId(postId);
    setComposerOpen(true);
  };

  return (
    <div className="flex-1 overflow-auto flex flex-col">
      <TopNav
        title="Publishing"
        action={{ label: 'New Post', onClick: openComposer }}
        secondaryAction={{ label: 'Capture from link', onClick: () => setCaptureOpen(true) }}
      />
      <div className="flex-1 overflow-auto mx-auto w-full max-w-[1400px]">
        <PostManager onEdit={openEditor} />
      </div>
      {captureOpen && (
        <CaptureModal
          onClose={() => setCaptureOpen(false)}
          onUse={({ mediaKeys, content }) => {
            setCaptureOpen(false);
            setInitialMediaKeys(mediaKeys);
            setInitialContent(content || undefined);
            setEditPostId(undefined);
            setComposerOpen(true);
          }}
        />
      )}
      {composerOpen && (
        <Composer
          onClose={() => setComposerOpen(false)}
          editPostId={editPostId}
          initialMediaKeys={initialMediaKeys.length ? initialMediaKeys : undefined}
          initialContent={initialContent}
        />
      )}
    </div>
  );
}
